import { browser } from '$app/environment';
import { patch_worksheet_user_data } from '$lib/utils/get_user_data';
import { patch_single_product_prices } from '$lib/utils/patch_localized_prices';

/** @type {import('./$types').LayoutLoad} */
export async function load({ parent, data, depends }) {
    depends('supabase:auth');

    let {
        supabase,
        session,
        teacher_allowed_product_ids = [],
        user_entitlements = []
    } = await parent();
    const has_teacher_access = teacher_allowed_product_ids.includes(
        data.worksheet.id
    );
    const has_entitlement = user_entitlements.includes(data.worksheet.id);
    const is_purchased = has_entitlement || has_teacher_access;

    if (browser) {
        if (session) {
            // Patch localized prices and user data in parallel
            let [worksheet_with_prices, worksheet_with_user_data] =
                await Promise.all([
                    patch_single_product_prices(data.worksheet),
                    patch_worksheet_user_data(
                        data.worksheet,
                        supabase,
                        session?.user?.id,
                        {
                            teacher_access: has_teacher_access,
                            is_purchased
                        }
                    )
                ]);

            // Merge the results - prices override user data for price fields
            data.worksheet = {
                ...worksheet_with_user_data,
                price: worksheet_with_prices.price
            };
        } else {
            // Only patch prices if no session
            data.worksheet = /** @type {Worksheet} */ (
                await patch_single_product_prices(data.worksheet)
            );
        }
    }

    return {
        supabase,
        session,
        ...data
    };
}
